var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "compress",
    d: "M38.929,46.286H27.857a2.138,2.138,0,0,1-2.143-2.143V33.071A1.075,1.075,0,0,1,26.786,32h3.571a1.075,1.075,0,0,1,1.071,1.071v7.5h7.5A1.075,1.075,0,0,1,40,41.643v3.571A1.075,1.075,0,0,1,38.929,46.286ZM14.286,44.143V33.071A1.075,1.075,0,0,0,13.214,32H9.643a1.075,1.075,0,0,0-1.071,1.071v7.5h-7.5A1.075,1.075,0,0,0,0,41.643v3.571a1.075,1.075,0,0,0,1.071,1.071H12.143A2.138,2.138,0,0,0,14.286,44.143Zm0,26.786V59.857a2.138,2.138,0,0,0-2.143-2.143H1.071A1.075,1.075,0,0,0,0,58.786v3.571a1.075,1.075,0,0,0,1.071,1.071h7.5v7.5A1.075,1.075,0,0,0,9.643,72h3.571A1.075,1.075,0,0,0,14.286,70.929Zm17.143,0v-7.5h7.5A1.075,1.075,0,0,0,40,62.357V58.786a1.075,1.075,0,0,0-1.071-1.071H27.857a2.138,2.138,0,0,0-2.143,2.143V70.929A1.075,1.075,0,0,0,26.786,72h3.571A1.075,1.075,0,0,0,31.429,70.929Z",
    transform: "translate(0 -32)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompress);
export default __webpack_public_path__ + "static/media/compress.dd0bb0a7bdd5c08131fde57253400fb5.svg";
export { ForwardRef as ReactComponent };